import axios from 'axios';
import _ from 'lodash';
import history from '../history';
import { v4 } from 'uuid';
import io from 'socket.io-client';
import { getBufferData } from '../localstorage';
import moment from 'moment';

// Start the amount of items in the order at 0
let payments_id = 1;
const API_URL = 'http://3.17.36.112:3090';

// Action types
export const ORDER_ADD = 'ORDER_ADD';
export const ORDER_ITEM_ADD = 'ORDER_ITEM_ADD';
export const ORDER_DELETE = 'ORDER_DELETE';
export const ORDER_NOTE_ADD = 'ORDER_NOTE_ADD';
export const ORDER_ITEMNOTE_ADD = 'ORDER_ITEMNOTE_ADD';
export const ORDER_DISCOUNT_ADD = 'ORDER_DISCOUNT_ADD';
export const ORDER_LOCATION_ADD = 'ORDER_LOCATION_ADD';
export const ORDER_MODIFIER_ADD = 'ORDER_MODIFIER_ADD';
export const ORDER_NAME_ADD = 'ORDER_NAME_ADD';
export const ORDER_RESET = 'ORDER_RESET';
export const ORDER_PAID = 'ORDER_PAID';
export const ORDER_SYNC = 'ORDER_SYNC';
export const ORDER_CLOSE = 'ORDER_CLOSE';
export const ORDERS_RESET = 'ORDERS_RESET';
export const ORDER_CALCULATE_TOTAL = 'ORDER_CALCULATE_TOTAL';
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE';
export const GET_MENU_ITEMS = 'MENU_ITEMS';
export const MENU_RESET = 'MENU_RESET';
export const AUTH_USER = 'AUTH_USER';
export const UNAUTH_USER = 'UNAUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const GET_OPEN_ORDERS = 'GET_OPEN_ORDERS';
export const GET_CLOSED_ORDERS = 'GET_CLOSED_ORDERS';
export const LOADING_CLOSED_ORDERS = 'LOADING_CLOSED_ORDERS';
export const LOADING_OPEN_ORDERS = 'LOADING_OPEN_ORDERS';
export const MORE_OPEN_ORDERS = 'MORE_OPEN_ORDERS';
export const MORE_CLOSED_ORDERS = 'MORE_CLOSED_ORDERS';
export const GET_ENDOFDAY_REPORT = 'GET_ENDOFDAY_REPORT';
export const GET_TIMESHEETS_REPORT = 'GET_TIMESHEETS_REPORT';
export const GET_DETAILED_ORDER_REPORT = 'GET_DETAILED_ORDER_REPORT';
export const LOADING_REPORT = 'LOADING_REPORT';
export const LOADING_TIMESHEET_REPORT = 'LOADING_TIMESHEET_REPORT';
export const RESET_REPORT = 'RESET_REPORT';
export const PUNCH_SUBMIT = 'PUNCH_SUBMIT';
export const PUNCH_SUBMITTING  = 'PUNCH_SUBMITTING';
export const PUNCH_RESET = 'PUNCH_RESET';
export const MODAL_OPEN_PAYMENT = 'MODAL_OPEN_PAYMENT';
export const MODAL_CLOSE_PAYMENT = 'MODAL_CLOSE_PAYMENT';
export const MODAL_ADD_ORDER_ID = 'MODAL_ADD_ORDER_ID';
export const MODAL_ADD_ITEM_ID = 'MODAL_ADD_ITEM_ID';
export const MODAL_ADD_CURRENTORDER_ITEM_ID = 'MODAL_ADD_CURRENTORDER_ITEM_ID';
export const MODAL_OPEN_ORDERNAME = 'MODAL_OPEN_ORDERNAME';
export const MODAL_CLOSE_ORDERNAME = 'MODAL_CLOSE_ORDERNAME';
export const MODAL_OPEN_ORDERNOTE = 'MODAL_OPEN_ORDERNOTE';
export const MODAL_CLOSE_ORDERNOTE = 'MODAL_CLOSE_ORDERNOTE';
export const MODAL_OPEN_ORDERDISCOUNT = 'MODAL_OPEN_ORDERDISCOUNT';
export const MODAL_CLOSE_ORDERDISCOUNT = 'MODAL_CLOSE_ORDERDISCOUNT';
export const MODAL_OPEN_ORDERCLOSE = 'MODAL_OPEN_ORDERCLOSE';
export const MODAL_CLOSE_ORDERCLOSE = 'MODAL_CLOSE_ORDERCLOSE';
export const MODAL_OPEN_ORDERLOCATION = 'MODAL_OPEN_ORDERLOCATION';
export const MODAL_CLOSE_ORDERLOCATION = 'MODAL_CLOSE_ORDERLOCATION';
export const MODAL_OPEN_PUNCH = 'MODAL_OPEN_PUNCH';
export const MODAL_CLOSE_PUNCH = 'MODAL_CLOSE_PUNCH';
export const MODAL_OPEN_ITEMMODIFIER = 'MODAL_OPEN_ITEMMODIFIER';
export const MODAL_CLOSE_ITEMMODIFIER = 'MODAL_CLOSE_ITEMMODIFIER';
export const MODAL_OPEN_ITEMNOTE = 'MODAL_OPEN_ITEMNOTE';
export const MODAL_CLOSE_ITEMNOTE = 'MODAL_CLOSE_ITEMNOTE';
export const MODAL_RESET = 'MODAL_RESET';
export const SET_NEXT_MODAL = 'SET_NEXT_MODAL';
export const CLEAR_NEXT_MODAL = 'CLEAR_NEXT_MODAL';
export const PAYMENT_ADD = 'PAYMENT_ADD';
export const CALCULATE_CHANGE = 'CALCULATE_CHANGE';
export const SERVER_STATUS = 'SERVER_STATUS';
export const CHECKING_SERVER = 'CHECKING_SERVER';
export const POLLING_TICK = 'POLLING_TICK';
export const POLLING_START = 'POLLING_START';
export const POLLING_STOP = 'POLLING_STOP';
export const AUTH_WS = 'AUTH_WS';
export const AUTH_FORGOT = 'AUTH_FORGOT';
export const AUTH_FORGOT_LOADING = 'AUTH_FORGOT_LOADING';
export const AUTH_RESET_SHOW = 'AUTH_RESET_SHOW';
export const AUTH_RESET_LOADING = 'AUTH_RESET_LOADING';
export const CURRENT_USER_ADD = 'CURRENT_USER_ADD';
export const EMPLOYEES_ADD = 'EMPLOYEES_ADD';
export const PUNCH_ADD = 'PUNCH_ADD';
export const PUNCH_OUT = 'PUNCH_OUT';

export function startSocketIO() {
  return (dispatch, getState) => {
    var socket = getState().auth.socket;

    // Check if the state already has a connected socket or not
    if (socket === undefined) {
      socket = io(API_URL);

      socket.on('connect', function () {
        //console.log('WS: Connected');
        socket
        .on('authenticated', function () {
          //console.log('WS: Authenticated');
          // We are authenticated, so save the socket in state
          dispatch({
            type: AUTH_WS,
            socket: socket,
          });

          // If we connect and there is unsent actions in the buffer, then send them
          const localSendBuffer = getBufferData();
          if (localSendBuffer !== undefined) {
            Array.prototype.push.apply(socket.sendBuffer, localSendBuffer);
            socket.emitBuffered();
            localStorage.removeItem('sendBuffer');
          }
        })
        .emit('authenticate', {token: localStorage.getItem('token')}); //send the jwt
      });

      socket.on("unauthorized", function(error, callback) {
        if (error.data.type === "UnauthorizedError" || error.data.code === "invalid_token") {
          //console.log("WS: The token sent is invalid");
          dispatch( { type: AUTH_ERROR, error: 'Could not connect to websockets' });
        }
      });

      socket.on('message', function(d) {
        console.log(d);
      });

      socket.on('receiveOrder', function(order) {
        dispatch(syncOrderReceive(order));
      });
    }
  }
}



// Add a completed order to the local state
export function addOrder(order) {
  return (dispatch, getState) => {
    let orderID = v4();
    dispatch({ type: ORDER_ADD, id: orderID, order: order });
    dispatch({ type: MODAL_ADD_ORDER_ID, id: orderID });

    let orders = getState().orders;
    dispatch(syncOrderSend(orders[orderID]));
  }
}

export function editOrder(orderID, action) {
  return (dispatch, getState) => {
    let orders = getState().orders;

    dispatch(syncOrderSend(orders[orderID], action));
  }
}

// Send a single order to the server to be synced
export function syncOrderSend(order, action) {
  return (dispatch, getState) => {
    let socket = getState().auth.socket;

    if (socket !== undefined) {
      socket.emit('sendOrder', order, action);
    } else {
      console.log("WS: Lost connection to API");
    }
  }
}

// When an order comes back from the API
export function syncOrderReceive(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ORDER_SYNC',
      localId: payload.data.localId,
      serverId: payload.data.serverId,
      updated: payload.updated,
    });

    //let orders = getState().orders;
    //console.log(orders[payload.data.localId]);
  }
}

export function syncData() {
  return (dispatch, getState) => {
    let orders = Object.values(getState().orders);

    // filter through orders and get the ones that have not been
    // synced with the server yet
    let unSyncedOrders = orders.filter(function(order) {
      return order.order_synced === false;
    });

    // Add any data here to send to the server (orders, punches?)
    let postData = {
      orders: unSyncedOrders,
    }

    // Send the un-synced orders to the server
    axios.post(`${API_URL}/syncdata`, postData, {
      headers: {
        "authorization": localStorage.getItem('token')
      }
    })
      .then(response => {
        if (response.data.synced) {
          // Send synced orders to the reducer to add server id
          dispatch(syncOrders(response.data.orders));
        }
      })
      .catch(error => {
        console.log("error", error);
      });
  }
}

export function syncOrders(orders) {
  console.log(orders);
  return dispatch => {
    orders.forEach(function(order) {
      dispatch({
        type: 'ORDER_SYNC',
        localId: order.localId,
        serverId: order.serverId,
      });
    });
  }
}

export function pollingStart() {
  return dispatch => {
    const interval = setInterval(() => {
      //dispatch(checkServer());
      dispatch({
        type: 'POLLING_TICK',
        time: Date.now()
      });
    }, 10000);

    dispatch({
      type: 'POLLING_START',
      offset: Date.now(),
      interval
    });
  }
}

export function pollingStop(interval) {
  clearInterval(interval);
  return {
    type: 'POLLING_STOP'
  }
}

export function checkServer() {
  return (dispatch, getState) => {
    const state = getState().polling;

    // Only check the server if we are not in the middle of a check already
    if (!(state.isFetching)) {
      dispatch({ type: CHECKING_SERVER, fetching: true });

      // Get the status of the server from the API
      axios.get(`${API_URL}/serverstatus`, {
        headers: { authorization: localStorage.getItem('token')}
      })
        .then(response => {
          dispatch({ type: CHECKING_SERVER, fetching: false });
          dispatch({ type: SERVER_STATUS, data: response.data });
          //console.log(response.data);

          // We have a connection, so good spot to sync order with the server
          //dispatch(syncOrders()); // Should be sync data?
        })
        .catch(error => {
          // No response, server is out?
          dispatch({ type: CHECKING_SERVER, fetching: false });
          dispatch({ type: SERVER_STATUS, data: { status: false } });
          //console.log(error.response.data.error);
        });
    }
  }
}

// Calculate change for the order
export function calculateChange(orderID, paymentsTotal) {
  return {
    type: CALCULATE_CHANGE,
    id: orderID,
    paymentsTotal: paymentsTotal,
  }
}

export function orderCalculateTotal() {
  return (dispatch, getState) => {
    const state = getState();

    // Calculate new order total
    let subtotal = 0.00;
    let hst = 0.00;
    let grandtotal = 0.00;

    subtotal = Object.keys(state.current_order.items).reduce(function (previous, key) {
      let price = state.current_order.items[key].price;
      let itemID = state.current_order.items[key].id;
      let categoryID = state.current_order.items[key].cat_id;
      let modifiers = state.current_order.items[key].modifiers;

      // Run through the modifiers to get the modifier prices added
      if (Object.keys(modifiers).length !== 0) {
        Object.keys(modifiers).forEach(groupID => {
          Object.keys(modifiers[groupID]).forEach(modifierID => {
            price += state.restaurant.menuItems[categoryID].items[itemID].modifiers[groupID].modifiers[modifierID].price;
          });
        });
      }

      return previous + price;
    }, 0);

    // Now we have subtotal, calculate discount, tax and grandtotal
    if (state.current_order.discount > 0) {
      grandtotal = (subtotal - subtotal * state.current_order.discount / 100);
    } else {
      grandtotal = subtotal;
    }

    // Calculate tax, this will be based on restaurant settings later
    hst = parseFloat((grandtotal * 0.13).toFixed(2));

    grandtotal += hst;
    dispatch({ type: ORDER_CALCULATE_TOTAL, subtotal: subtotal, hst: hst, grandtotal: grandtotal });
  }
}

// Add modifiers to an item in the current order
export function orderItemModifierAdd(currentOrderID, modifiers) {
  return dispatch => {
    dispatch({ type: ORDER_MODIFIER_ADD, id: currentOrderID, modifiers: modifiers });
    dispatch(orderCalculateTotal());
  }
}

// Add an Order ID to the payment modal so it knows what order to load
export function addModalOrderID(orderID) {
  return dispatch => {
    dispatch({ type: MODAL_ADD_ORDER_ID, id: orderID });

    return Promise.resolve();
  }
}

// This function can be removed
export function addModalItemID(categoryID, itemID) {
  return dispatch => {
    dispatch({ type: MODAL_ADD_ITEM_ID, itemID: itemID,  categoryID: categoryID });

    return Promise.resolve();
  }
}

export function addModalCurrentOrderItemID(itemID) {
  return dispatch => {
    dispatch({ type: MODAL_ADD_CURRENTORDER_ITEM_ID, id: itemID });

    return Promise.resolve();
  }
}

// Reset the current order
export function orderReset() {
  return {
    type: ORDER_RESET,
  };
}

// Reset all the orders in the reducer
export function ordersReset() {
  return {
    type: ORDERS_RESET,
  }
}

// Add a payment to the current order
export function addPayment(orderID, paymentType, paymentAmount) {
  return dispatch => {
    dispatch({ type: PAYMENT_ADD, orderID: orderID, id: payments_id++, paymentType: paymentType, paymentAmount: paymentAmount });

    return Promise.resolve();
  }
}

// Change the order to be paid (payments are more than total)
export function orderPaid(orderID) {
  return dispatch => {
    dispatch({ type: ORDER_PAID, id: orderID, });
    dispatch(editOrder(orderID, 'add_payments'));
  }
}

export function orderClose(orderID) {
  return dispatch => {
    dispatch({ type: ORDER_CLOSE, id: orderID });
    dispatch(editOrder(orderID, 'close_order'));

    return Promise.resolve();
  }
}

export function clearNextModal() {
  return {
    type: CLEAR_NEXT_MODAL,
  };
}

export function setNextModal(modal) {
  return {
    type: SET_NEXT_MODAL,
    modal: modal,
  };
}

export function openOrderCloseModal() {
  return {
    type: MODAL_OPEN_ORDERCLOSE,
  };
}

export function closeOrderCloseModal() {
  return (dispatch, getState) => {
    const state = getState().modals;
    dispatch({ type: MODAL_CLOSE_ORDERCLOSE });
    if (typeof(state["nextModal"]) === "function") {
      state["nextModal"]();
      dispatch({ type: CLEAR_NEXT_MODAL });
    }
  }
}

export function openItemNoteModal() {
  return {
    type: MODAL_OPEN_ITEMNOTE,
  }
}

export function closeItemNoteModal() {
  return {
    type: MODAL_CLOSE_ITEMNOTE,
  };
}

export function openItemModifierModal() {
  return {
    type: MODAL_OPEN_ITEMMODIFIER,
  };
}

export function closeItemModifierModal() {
  return {
    type: MODAL_CLOSE_ITEMMODIFIER,
  };
}

export function openPunchModal() {
  return {
    type: MODAL_OPEN_PUNCH,
  };
}

export function closePunchModal() {
  return {
    type: MODAL_CLOSE_PUNCH,
  };
}

export function openOrderDiscountModal() {
  return {
    type: MODAL_OPEN_ORDERDISCOUNT,
  };
}

export function closeOrderDiscountModal() {
  return {
    type: MODAL_CLOSE_ORDERDISCOUNT,
  };
}

export function openOrderLocationModal() {
  return {
    type: MODAL_OPEN_ORDERLOCATION,
  };
}

export function closeOrderLocationModal() {
  return (dispatch, getState) => {
    const state = getState().modals;
    dispatch({ type: MODAL_CLOSE_ORDERLOCATION });
    if (typeof(state["nextModal"]) === "function") {
      state["nextModal"]();
      dispatch({ type: CLEAR_NEXT_MODAL });
    }
  }
}

export function openOrderNoteModal() {
  return {
    type: MODAL_OPEN_ORDERNOTE,
  };
}

export function closeOrderNoteModal() {
  return {
    type: MODAL_CLOSE_ORDERNOTE,
  };
}

export function openOrderNameModal() {
  return {
    type: MODAL_OPEN_ORDERNAME,
  };
}

export function modalReset() {
  return {
    type: MODAL_RESET,
  };
}

export function closeOrderNameModal() {
  return (dispatch, getState) => {
    const state = getState().modals;
    dispatch({ type: MODAL_CLOSE_ORDERNAME });
    if (typeof(state["nextModal"]) === "function") {
      state["nextModal"]();
      dispatch({ type: CLEAR_NEXT_MODAL });
    }
  }
}

export function openPaymentModal() {
  return {
    type: MODAL_OPEN_PAYMENT,
  };
}

export function closePaymentModal() {
  return (dispatch, getState) => {
    const state = getState().modals;
    dispatch({ type: MODAL_CLOSE_PAYMENT });
    if (typeof(state["nextModal"]) === "function") {
      state["nextModal"]();
      dispatch({ type: CLEAR_NEXT_MODAL });
    }
  }
}

export function openOpenOrders() {
  return dispatch => {
    dispatch({ type: ORDER_RESET });
    history.push('/pos/openorders');
  }
}

export function menuReset() {
  return dispatch => {
    dispatch({ type: MENU_RESET });
  }
}

// Action creators
export function signoutUser() {
  return function(dispatch, getState) {
    const state = getState().polling;

    localStorage.removeItem('token');

    // Reset most of the state
    dispatch(menuReset());
    dispatch(orderReset());
    dispatch(ordersReset());

    dispatch(pollingStop(state.interval));
    dispatch({ type: UNAUTH_USER });
  }
}

export function fetchMessage() {
  return function(dispatch) {
    axios.get(`${API_URL}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        console.log(response);
      });
  }
}

export function signinUser({email, password}, redirect, restaurant) {
  return function(dispatch) {
    // Submit email/password to the server
    axios.post(`${API_URL}/signin`, { email, password, restaurant })
      .then(response => {
        // Update state that user is auth'd
        dispatch({ type: AUTH_USER });

        // Save JWT
        localStorage.setItem('token', response.data.token);

        dispatch({ type: CURRENT_USER_ADD, payload: response.data.user });
        dispatch(getRestaurantInfo());

        // redirect user to the path that is passed
        redirect();
      })
      .catch( () => {
        // Show an error to the user
        dispatch(authError('Wrong email or password'));
      });
  }
}

export function signupUser({ email, password }, redirect) {
  return function(dispatch) {
    // Submit email/password to the server
    axios.post(`${API_URL}/signup`, {email, password})
      .then(response => {
        dispatch({ type: AUTH_USER });
        //console.log(response.data);
        redirect();
      })
      .catch(error => {
        //console.log(error.response.data.error);
        dispatch(authError(error.response.data.error))
      });
  }
}

export function forgotPassword(email) {
  return function(dispatch) {
    // submit email for password reset to the API
    dispatch({ type: AUTH_FORGOT_LOADING, payload: true });
    axios.post(`${API_URL}/forgotpassword`, {email})
      .then(response => {
        dispatch({ type: AUTH_FORGOT, payload: false });
        dispatch({ type: AUTH_FORGOT_LOADING, payload: false });
      })
      .catch(error => {
        dispatch(authError(error.response.data.error));
        dispatch({ type: AUTH_FORGOT_LOADING, payload: false });
      });
  }
}

export function passwordReset(password, passwordAgain, token) {
  return function(dispatch) {
    // submit email for password reset to the API
    dispatch({ type: AUTH_FORGOT_LOADING, payload: true });
    axios.post(`${API_URL}/passwordreset`, {password, passwordAgain, token})
      .then(response => {
        dispatch({ type: AUTH_RESET_SHOW, payload: false });
        dispatch({ type: AUTH_RESET_LOADING, payload: false });
      })
      .catch(error => {
        dispatch(authError(error.response.data.error));
        dispatch({ type: AUTH_RESET_LOADING, payload: false });
      });
  }
}

export function resetForgotPassword() {
  return {
    type: AUTH_FORGOT,
    payload: true,
  }
}

export function authError(error) {
  return {
    type: AUTH_ERROR,
    payload: error
  };
}

export function orderItemAdd(item) {
  return function (dispatch, getState) {
    const state = getState().current_order;
    let itemID = state.lastItemID + 1;

    dispatch({ type: ORDER_ITEM_ADD, id: itemID, item: item });
    dispatch(orderCalculateTotal());
  }
}

export function orderDelete(id) {
  return function (dispatch) {
    dispatch({ type: ORDER_DELETE, id: id });
    dispatch(orderCalculateTotal());
  }
}

export function orderItemnoteAdd(id, note) {
  return {
    type: ORDER_ITEMNOTE_ADD,
    id: id,
    note: note
  }
}

export function orderNoteAdd(note) {
  return {
    type: ORDER_NOTE_ADD,
    note: note
  }
}

export function orderDiscountAdd(discount) {
  return function (dispatch) {
    dispatch({ type: ORDER_DISCOUNT_ADD, discount: discount });
    dispatch(orderCalculateTotal());
  }
}

export function orderLocationAdd(location) {
  return function(dispatch) {
    dispatch({ type: ORDER_LOCATION_ADD, location: location });
  }
}

export function orderNameAdd(name, action = 'send') {
  return function(dispatch) {
    dispatch({ type: ORDER_NAME_ADD, order_name: name });

    return Promise.resolve();
  }
}

export function categoryUpdate(cat_id, items) {
  return {
    type: CATEGORY_UPDATE,
    id: cat_id,
    items: items
  }
}

export function getRestaurantInfo() {
  return function(dispatch, getState) {
    const state = getState().restaurant;

    axios.get(`${API_URL}/restaurantinfo`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        //console.log(response);
        dispatch({ type: GET_MENU_ITEMS, payload: response.data.menu });
        dispatch({ type: CATEGORY_UPDATE, id: parseInt(Object.keys(response.data.menu)[0], 10) });
        dispatch({ type: EMPLOYEES_ADD, payload: response.data.employees });
      })
      .catch(error => {
        console.log("ERROR: Could not connect to server to get menu items, relying on local state");
        if (!_.isEmpty(state.menuItems)) {
          dispatch({ type: CATEGORY_UPDATE, id: parseInt(Object.keys(state.menuItems)[0], 10) })
        }
      });
  }
}

export function get_endofday_report(date) {
  return function(dispatch) {
    dispatch({ type: LOADING_REPORT, loading: true });

    axios.get(`${API_URL}/getendofday?date=${date}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data)) {
          dispatch({ type: GET_ENDOFDAY_REPORT, payload: response.data, status: false });
        } else {
          dispatch({ type: GET_ENDOFDAY_REPORT, payload: response.data, status: true });
        }
      });
  }
}

export function get_timesheets_report(from, to) {
  return function(dispatch) {
    dispatch({ type: LOADING_TIMESHEET_REPORT, loading: true });

    axios.get(`${API_URL}/gettimesheets?date_from=${from}&date_to=${to}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data)) {
          dispatch({ type: GET_TIMESHEETS_REPORT, payload: response.data, status: false });
        } else {
          dispatch({ type: GET_TIMESHEETS_REPORT, payload: response.data, status: true });
        }
      });
  }
}

export function get_detailed_order_report(from, to) {
  return function(dispatch) {
    dispatch({ type: LOADING_REPORT, loading: true });

    axios.get(`${API_URL}/getdetailedorders?date_from=${from}&date_to=${to}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data)) {
          dispatch({ type: GET_DETAILED_ORDER_REPORT, payload: response.data, status: false });
        } else {
          dispatch({ type: GET_DETAILED_ORDER_REPORT, payload: response.data, status: true });
        }
      });
  }
}

export function report_reset() {
  return {
    type: RESET_REPORT
  }
}

// Compare employee_num with local employee list
export function addPunch(employeeNumber) {
  return function(dispatch, getState) {
    let punches = getState().punches;
    let employees = getState().restaurant.employees;
    employeeNumber = parseInt(employeeNumber, 10);

    if (!employeeNumber) {
      return Promise.resolve("You must enter an employee ID");
    }

    let punched = employees.find(employee => employee.employee_num === employeeNumber);

    // Did we find an employee num that matches?
    if (punched !== undefined) {

      // Convert punches reducer to an array to search
      let punchesArr = Object.values(punches);

      // Is this employee num already punched in?
      let punchOutCheck = punchesArr.find(
        punch => (punch.punchIn && !punch.punchOut && punch.employeeNumber === employeeNumber)
      );

      if (punchOutCheck) {
        // We are punching out, so edit punch
        let punchOut = moment().format('YYYY-MM-DD HH:mm:ss');

        dispatch({ type: PUNCH_OUT, id: punchOutCheck.id, punchOut: punchOut });

        return Promise.resolve("You are clocked out at: " + punchOut);
      } else {
        // We are punching in, so add new punch
        let punchID = v4();
        let punchIn = moment().format('YYYY-MM-DD HH:mm:ss');
        let punch = {

          employeeID: punched.employee_id,
          employeeNumber: punched.employee_num,
          punchIn: punchIn,
          punchOut: '',
        };
        dispatch({ type: PUNCH_ADD, id: punchID, punch: punch });

        // Send our punch in to API as well
        let punches = getState().punches;
        dispatch(syncPunchSend(punches[punchID], 'add'));

        return Promise.resolve("You are clocked in at: " + punchIn);
      }
      //let punches2 = getState().punches;
      //console.log(punches2);
    } else {
      return Promise.resolve("Invalid employee ID")
    }
  }
}

export function syncPunchSend(punch, action) {
  return (dispatch, getState) => {
    let socket = getState().auth.socket;

    if (socket !== undefined) {
      socket.emit('sendPunch', punch, action);
    } else {
      console.log("WS: Lost connection to API");
    }
  }
}

// When an order comes back from the API
export function syncPunchReceive(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PUNCH_SYNC',
      localId: payload.data.localId,
      serverId: payload.data.serverId,
      updated: payload.updated,
    });

    //let orders = getState().orders;
    //console.log(orders[payload.data.localId]);
  }
}

export function submit_punch(employee_num) {
  return function(dispatch) {
    dispatch({ type: PUNCH_SUBMITTING, loading: true });

    axios.get(`${API_URL}/submitpunch?employee_num=${employee_num}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data)) {
          dispatch({ type: PUNCH_SUBMIT, payload: response.data, status: false });
        } else {
          dispatch({ type: PUNCH_SUBMIT, payload: response.data, status: true });
        }
      });
  }
}

export function edit_punch(punchcardid, employee_id, date, punch_in, punch_out, from, to) {
  return function(dispatch) {
    dispatch({ type: LOADING_TIMESHEET_REPORT, loading: true });

    axios.get(`${API_URL}/editpunch?punchcardid=${punchcardid}&employee_id=${employee_id}&date=${date}&punch_in=${punch_in}&punch_out=${punch_out}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (response.data.status === "success") {
          dispatch(get_timesheets_report(from, to));
        }
      });
  }
}

export function add_punch(employee_id, date, punch_in, punch_out, from, to) {
  return function(dispatch) {
    dispatch({ type: LOADING_TIMESHEET_REPORT, loading: true });

    axios.get(`${API_URL}/addpunch?employee_id=${employee_id}&date=${date}&punch_in=${punch_in}&punch_out=${punch_out}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (response.data.status === "success") {
          dispatch(get_timesheets_report(from, to));
        }
      });
  }
}

export function delete_punch(punchcardid, from, to) {
  return function(dispatch) {
    dispatch({ type: LOADING_TIMESHEET_REPORT, loading: true });

    axios.get(`${API_URL}/deletepunch?punchcardid=${punchcardid}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (response.data.status === "success") {
          dispatch(get_timesheets_report(from, to));
        }
      });
  }
}

export function punch_reset() {
  return {
    type: PUNCH_RESET
  }
}


export function get_open_orders(page = 1, search = '') {
  return function(dispatch) {
    dispatch({ type: LOADING_OPEN_ORDERS, loading: true });

    axios.get(`${API_URL}/getopenorders?page=${page}&search=${search}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data.orders)) {
          dispatch({ type: GET_OPEN_ORDERS, payload: response.data.orders, status: false });
        } else {
          dispatch({ type: GET_OPEN_ORDERS, payload: response.data.orders, status: true });
        }
      });
  }
}

export function get_more_open_orders(page = 1, search = '') {
  return function(dispatch) {
    axios.get(`${API_URL}/getopenorders?page=${page}&search=${search}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data.orders)) {
          dispatch({ type: MORE_OPEN_ORDERS, payload: response.data.orders, status: false });
        } else {
          dispatch({ type: MORE_OPEN_ORDERS, payload: response.data.orders, status: true });
        }
      });
  }
}



export function getClosedOrders(page = 1, date = 'older', search='') {
  return (dispatch) => {
    dispatch({ type: LOADING_CLOSED_ORDERS, loading: true });

    axios.get(`${API_URL}/getclosedorders?page=${page}&date=${date}&search=${search}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data.orders)) {
          dispatch({ type: GET_CLOSED_ORDERS, payload: response.data.orders, status: false });
        } else {
          dispatch({ type: GET_CLOSED_ORDERS, payload: response.data.orders, status: true });
        }
      });
  }
}

export function get_more_closed_orders(page = 1, date = 'today', search='') {
  return function(dispatch) {
    axios.get(`${API_URL}/getclosedorders?page=${page}&date=${date}&search=${search}`, {
      headers: { authorization: localStorage.getItem('token')}
    })
      .then(response => {
        if (_.isEmpty(response.data.orders)) {
          dispatch({ type: MORE_CLOSED_ORDERS, payload: response.data.orders, status: false });
        } else {
          dispatch({ type: MORE_CLOSED_ORDERS, payload: response.data.orders, status: true });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js